var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-switcher" }, [
    _c(
      "div",
      { staticClass: "layout-row justify-between" },
      [
        _c("OrSwitch", {
          attrs: {
            "model-value": _vm.isDark,
            label: _vm.$t("HITL.modules.app-header.dark-mode"),
          },
          on: { "update:modelValue": _vm.toggleTheme },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "typography-caption-regular text-on-disabled dark:text-on-disabled-dark",
          },
          [_vm._v("\n      " + _vm._s(_vm.getDarkModeHotkey) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }